// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2P6Vd","footer":"ReportModalFilter_footer__2FrcO"};